import {modal as ContinueSessionModal} from './modals/ContinueSession';

const getErrorBag = (element) => {
    if (element.nextElementSibling) {
        if (element.nextElementSibling.classList.contains('errors')) {
            return element.nextElementSibling;
        }
    }

    const newErrorElement = document.createElement('p');
    newErrorElement.classList.add('errors', 'text-danger');
    newErrorElement.style.fontSize = '0.8em';
    newErrorElement.style.marginTop = '1em';
    newErrorElement.style.padding = '1em';
    element.after(newErrorElement);

    return newErrorElement;
};

const actions = {
    firebaseCreate: async (element, type, data, container, event) => {
        const firebase = container.componentList.FirebaseStorage;
        const user = firebase.data();

        Logger.info("Create", user);
        
        var validation = actions.validateCarouselSlide( element, type, data, container, event );

        Logger.info("Valida", validation);

        if( !validation ) return Promise.resolve(false);

        // debugger;


        const initialText = element.innerText;
        element.style.pointerEvents = 'none';
        element.style.opacity = '0.5';
        element.innerText = LanguageManager.getString('loading');

        var date = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, ''); // '2012-11-04 14:55:45'

        container.componentList.FirebaseStorage.setUserProperty("dateCreated", date);
        container.componentList.FirebaseStorage.setUserProperty("dateLastAccess", date)

        // console.info("Create", user);

        const response = await firebase.createWithEmail(user.email)
            .then(async response => {
                event.view.complete();

                container.componentList.LRSConnector.load(`${user.firstName} ${user.lastName}`, user.email);
                // container.router.next();
                container.router.navigate('page/coursemap', {
                    trigger: true
                });
            })
            .catch(error => {
                const errorBag = getErrorBag(element);
                errorBag.innerHTML = '';
                const msg = document.createElement('span');
                msg.innerText = error.message + ' ';
                const link = document.createElement('a');
                link.href = '#';
                link.innerText = LanguageManager.getString('login');
                link.addEventListener('click', () => actions.showModal(element, type, data, container, event));
                errorBag.appendChild(msg);
                errorBag.appendChild(link);
                Logger.error('sign up error', error);
                element.style.pointerEvents = 'initial';
                element.style.opacity = '1';
                element.innerText = initialText;
            });
    },
    submit: (element, type, data, container, event) => {
        const form = event.view.el.querySelector('form');
        form.action = '#';
        form.submit();
    },
    nextSlide: (element, type, data, container, event) => {
        container.router.next();
    },
    continueAs: (element, type, data, container, event) => {
		const user = container.componentList.FirebaseStorage.data();

        var date = String(new Date().toJSON().substring(0, 10) ).split("-").reverse().join("/"); // DD/MM/YYYY
        var date = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, ''); // '2012-11-04 14:55:45'

        container.componentList.FirebaseStorage.setUserProperty("dateLastAccess", date)

        container.componentList.FirebaseStorage.save()
        Logger.info("Lrs.continueAs.start", user)
        
        Logger.info("Navigation.continueAs.Firebase.user", user);

        Array.from(element.closest('.screen-wrapper').querySelectorAll('.action-button'))
            .forEach(el => el.classList.add('disabled'));
        // Logger.info("Lrs.continueAs.buttons.disabled")

		container.componentList.LRSConnector.loadStateByEmail(user.email)
            .then(() => {
                container.componentList.LRSConnector.load(`${user.firstName} ${user.lastName}`, user.email);

                let pageID = container.storage.getBookmark();

                // If the user doesn't have a bookmark yet, send them to the help page
                pageID = pageID === -1 ? 'coursemap' : pageID;

                Logger.info("Lrs.continueAs", pageID)
                Logger.info("Navigation.continueAs", data);
                container.router.navigate(data.data, {
                    trigger: true
                });

                // container.router.navigate(`global/coursemap`, {
                //     trigger: true
                // });
            })
            .catch(error => {
                const errorBag = getErrorBag(element);

                if (error.code === 'no_user_data') {
                    errorBag.innerText = LanguageManager.getString('thats_me_error_no_user_data');
                }
                if (error.code === 'request_aborted') {
                    errorBag.innerText = LanguageManager.getString('thats_me_error_request_aborted');
                }
            })
        ;
    },
    accountNew: async (element, type, data, container, event) => {
		await container.componentList.FirebaseStorage.logout();
		container.componentList.LRSConnector.load();

        if(data) {
            // Logger.info("Router to ", data)
            container.router.navigate(data, {
                    trigger: true
                });
            return;
        }

        container.router.next();
    },
    saveProfile: async (element, type, data, container, event) => {
        Logger.info("SAVEEEEEEE........ start ")
        const elements = Array.from(event.view.el.querySelectorAll('*'));
        const filtered = elements.filter(el => !!el.validation)
        filtered.forEach(el => {
            el.validation.validate();
        })
        const invalid = filtered.filter(el => el.validation.invalid())
        const valid = invalid.length === 0;

        Logger.info({
            elements,
            filtered,
            invalid,
            valid,
        })

        if (!valid) {
            return;
        }

        const saveSuccessful = await container.componentList.FirebaseStorage.save();

        Logger.info({saveSuccessful});

        if (!saveSuccessful) {
            Array.from(event.view.el.querySelectorAll('*'))
                .filter(el => !!el.validation)
                .forEach(el => el.validation.clearHints())
            return;
        }

        element.innerText = LanguageManager.getString('saving');

        Logger.info('redirect');
        container.router.navigate('return-to-course', {
			trigger: true
		});
        element.innerText = LanguageManager.getString('saved');
    },
    logout: async (element, type, data, container, event) => {
        Array.from(element.closest('.screen-wrapper').querySelectorAll('.action-button'))
            .forEach(el => el.classList.add('disabled'));
        await container.componentList.FirebaseStorage.logout();
        
        if(data) {
            // Logger.info("Router to ", data.data)
            container.router.navigate(data.data, {
                trigger: true
            });

            // return;
        }

        // container.router.navigate(`page/010_015`, {
        //     trigger: true
        // });
    },
    showModal: (element, type, data, container, event) => {
        ContinueSessionModal(element, type, data, container, event);
    },
    validateCarouselSlide(element, type, data, container, event) {
        const carousel = event.view.$carousel;
        if (!carousel) {
            Logger.warn(`Cannot validate carousel slides if it isn't a carousel`);
            return;
        }

        const slide = carousel[0].querySelector('.slide.active');

        if (!slide) {
            return;
        }

        var results = [];

        Array.from(slide.querySelectorAll('*'))
            .filter(el => !!el.validation)
            .forEach(el => {
                el.validation.validate();
                var result = el.validation.valid();

                results.push( result );

                // Logger.info("Result.", result )
            });
        
        Logger.info("Validation.check", results);
        return results.includes( false ) ? false : true;
    },
    carouselNext: (element, type, data, container, event) => {
        if (!event.view.$carousel) {
            return;
        }
        event.view.next();
    },
};

export default {
    render(data) {
        const props = {
            href: data.href || '#',
        };

        if (data.modal) {
            props['data-micromodal-trigger'] = data.modal;
        }

        const element = document.createElement('a');
        if (data.class) {
            const classes = data.class.split(/[\s,]/);
            element.classList.add(...classes);
        }
        element.innerText = data.text || '';
        element.style.marginTop = '0';
        element.setAttribute('role', 'button');
        element.setAttribute('tabindex', '0');
        Object.entries(props).forEach(function(pair) {
            element.setAttribute(pair[0], pair[1]);
        });

        return element;
    },
    postRender(element, type, data, container, event) {
        Logger.info("Data", element, type, data, container, event)
        if (data.action) {
            data.action.split(',').forEach(action => {
                element.addEventListener(
                    'click',
                    () => actions[action](element, type, data, container, event)
                );
            });
        }
    },
};